export const TEST_MODE_LIFECYCLE_STORAGE_KEY = 'quizivaTestModeLifecycleId';
export const TEST_MODE_LIFECYCLE_HEADER = 'X-Quiziva-Test-Mode-Lifecycle-Id';
export const TEST_MODE_HEADER = 'X-Quiziva-Test-Mode';
export const TEST_MODE_RECOVERY_HEADER = 'X-Quiziva-Test-Mode-Recovery';
export const TEST_MODE_RECOVERY_VALUE = 'confirm-stale-cleanup';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getTestModeLifecycleId(
  storage: Storage = localStorage,
): string | null {
  const value = storage.getItem(TEST_MODE_LIFECYCLE_STORAGE_KEY)?.trim() || '';
  return UUID_PATTERN.test(value) ? value.toLowerCase() : null;
}

export function ensureTestModeLifecycleId(
  storage: Storage = localStorage,
  createUuid: () => string = () => crypto.randomUUID(),
): string {
  const existing = getTestModeLifecycleId(storage);
  if (existing) return existing;

  const lifecycleId = createUuid().toLowerCase();
  if (!UUID_PATTERN.test(lifecycleId)) {
    throw new Error('Unable to create a valid test-mode lifecycle UUID.');
  }
  storage.setItem(TEST_MODE_LIFECYCLE_STORAGE_KEY, lifecycleId);
  return lifecycleId;
}

export function clearTestModeLifecycleId(storage: Storage = localStorage): void {
  storage.removeItem(TEST_MODE_LIFECYCLE_STORAGE_KEY);
}

export function getTestModePreviewHeaders(
  storage: Storage = localStorage,
): Record<string, string> {
  const previewEnabled =
    storage.getItem('quizivaTestPreviewModeEnabled') === 'true';
  const testModeEnabled = storage.getItem('quizivaTestModeEnabled') === 'true';
  const lifecycleId = getTestModeLifecycleId(storage);
  if (!previewEnabled || !testModeEnabled || !lifecycleId) return {};

  return {
    [TEST_MODE_HEADER]: 'true',
    [TEST_MODE_LIFECYCLE_HEADER]: lifecycleId,
  };
}
